import _ from 'underscore';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

let dynamicTextMenu = [
  { text: i18n.get('Ad_DynamicMenuParam1'), value: '{param1}' },
  { text: i18n.get('Ad_DynamicMenuParam2'), value: '{param2}' },
  { text: i18n.get('Ad_DynamicMenuParam3'), value: '{param3}' },
];

export default {
  extend(viewModel, propertyNames) {
    _.each(propertyNames, (name) => {
      const property = viewModel[name];

      property.appendDynamicText = (data) => {
        const originalValue = property();

        property(originalValue + data.value);
      };

      property.dynamicTextMenu = dynamicTextMenu;
    });
  },
};
